var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail-view"},[(_vm.hasThumbnailSrc)?_c('div',[_c('img',{staticClass:"image",attrs:{"src":_vm.imgSrc,"width":_vm.width,"height":_vm.height}})]):_c('div',{staticClass:"flex items-center"},[_c('document-icon',{attrs:{"svgClasses":"h-12 w-12","type":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }